import React from 'react';
import GenericModal from 'components/generic-modal/GenericModal';
import { DeleteIcon, NavCloseIcon } from 'assets/icons';

interface DeleteCOFModalProps {
  isActionInProgress?: boolean;
  onPrimaryBtnClick: () => void;
  onSecondaryBtnClick: () => void;
  onCloseIconClick: () => void;
  primaryBtnLabel?: string;
  secondaryBtnLabel?: string;
  subTitle?: string;
  title?: string;
  className?: string;
}

const DeleteCOFModal: React.FC<DeleteCOFModalProps> = ({
  isActionInProgress = false,
  onPrimaryBtnClick,
  onSecondaryBtnClick,
  onCloseIconClick,
  primaryBtnLabel = 'Yes, delete card on file',
  secondaryBtnLabel = 'Cancel',
  subTitle = 'Are your sure? Do you want to delete this card?',
  title = 'Confirm deletion',
  className = '!p-5'
}) => {
  const deleteIconWithBg = () => (
    <div className="mb-6 flex h-[50px] w-[50px] items-center justify-center rounded-full bg-secondaryBtn">
      <DeleteIcon className="h-5 w-5 shrink-0" />
    </div>
  );

  const closeIcon = () => <NavCloseIcon className="h-3 w-3 shrink-0 cursor-pointer" onClick={onCloseIconClick} />;

  return (
    <GenericModal
      showModal={true}
      isActionInProgress={isActionInProgress}
      MainIcon={deleteIconWithBg}
      CloseIcon={closeIcon}
      title={title}
      titleStyle="text-primaryText"
      subTitle={subTitle}
      subTitleStyle="text-center px-10 text-primaryText"
      primaryBtnLabel={primaryBtnLabel}
      primaryBtnId="confirm-delete-card-btn"
      onPrimaryBtnClick={onPrimaryBtnClick}
      secondaryBtnLabel={secondaryBtnLabel}
      secondaryBtnId="cancel-delete-card-btn"
      onSecondaryBtnClick={onSecondaryBtnClick}
      onCloseIconClick={onCloseIconClick}
      primaryBtnStyle="text-primary mb-4"
      className={className}
      closeIconStyle="top-5 right-5"
    />
  );
};

export default DeleteCOFModal;
